// Core
import React from 'react';

// Components
import { MainNavigation } from '../MainNavigation';

// Component
import { CustomerPanelProps } from './CustomerPanel.types';
import { Container, MainNavigationContainer } from './CustomerPanel.style';

function CustomerPanel({
  children,
  className,
  testId,
}: CustomerPanelProps): JSX.Element {
  return (
    <Container
      data-testid={testId}
      className={className}
    >
      <MainNavigationContainer>
        <MainNavigation testId="main-navigation" />
      </MainNavigationContainer>
      {children}
    </Container>
  );
}

export { CustomerPanel };
